import { useRef, useState } from 'react'
import { useNavigate } from 'react-router'
import { useGame } from '../GameContext'
import { PLAYER_COLORS } from '../constants'
import { Button, GolfBall, Input, WashiTape } from '../components/ui'
import { ArrowRight, UserPlus } from 'lucide-react'

export default function SetupPlayers() {
  const navigate = useNavigate()
  const { gameState, addPlayer, updatePlayerColor } = useGame()
  const [name, setName] = useState('')
  const inputRef = useRef(null)

  const add = () => {
    if (name.trim()) {
      const color = PLAYER_COLORS[gameState.players.length % PLAYER_COLORS.length]
      addPlayer({
        id: Date.now().toString(),
        name: name.trim(),
        selectedColor: color.name,
      })
      setName('')
      inputRef.current?.focus()
    }
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') add()
  }

  return (
    <div className="min-h-screen flex flex-col py-6">
      <div className="flex-1 max-w-md w-full mx-auto space-y-6">
        <div className="space-y-2 relative text-center">
          <WashiTape className="-top-3 left-1/2 -translate-x-1/2" rotation="-3deg" />
          <h2 className="text-2xl font-hand relative z-10">Spelen bij {gameState.course.name}</h2>
          <p className="text-base text-muted-foreground">Voeg alle spelers in je groep toe</p>
        </div>

        <div className="flex gap-2">
          <Input
            ref={inputRef}
            autoFocus
            type="text"
            placeholder="Voer spelersnaam in"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyPress={onKeyDown}
            className="h-12 text-lg bg-primary/10 rounded-md"
          />
          <Button onClick={add} size="lg" className="px-4 h-12 w-12">
            <UserPlus className="h-6 w-6" />
          </Button>
        </div>

        {gameState.players.length > 0 && (
          <div className="space-y-3">
            <h3 className="text-base font-medium">Spelers ({gameState.players.length})</h3>
            <div className="space-y-3">
              {gameState.players.map((player) => (
                <div key={player.id} className="flex items-center justify-between py-2">
                  <span className="font-regular">{player.name}</span>
                  <div className="flex gap-2">
                    {PLAYER_COLORS.map((color) => (
                      <button
                        key={color.name}
                        aria-label={`Select ${color.name} color for ${player.name}`}
                        className={`transition-transform rounded-full hover:scale-110 ${
                          player.selectedColor === color.name ? 'ring-2 ring-offset-1 ring-primary' : ''
                        }`}
                        onClick={() => updatePlayerColor(player.id, color.name)}
                        type="button"
                      >
                        <GolfBall color={color.bg} />
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {gameState.players.length === 0 && (
          <div className="p-8 text-center">
            <UserPlus className="h-12 w-12 mx-auto mb-3 text-muted-foreground opacity-50" />
            <p className="text-muted-foreground">Nog geen spelers toegevoegd</p>
            <p className="text-sm text-muted-foreground mt-1">
              Voeg minimaal één speler toe om te beginnen
            </p>
          </div>
        )}

        {gameState.players.length >= 1 && (
          <Button onClick={() => navigate('/rules')} variant="outline" className="w-full" size="lg">
            <ArrowRight className="mr-2 h-5 w-5" />
            Naar spelregels
          </Button>
        )}
      </div>
    </div>
  )
}